import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';

export default function LoadingIndicator() {
  const { isLoading } = useSelector((state) => state.app);
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
